import {WebsiteInitialData_CachedQuery} from '@data/__generated__/types.main'
import {SSRConfig} from 'next-i18next'

import TrackV2Page, {getStaticProps as getV2StaticProps} from './trackv2'

export interface TrackProps {
  _nextI18Next: SSRConfig['_nextI18Next']
  initialData: WebsiteInitialData_CachedQuery
  websiteId: string
  lastRevalidatedAt: string
  isV2: boolean
}

export default function TrackPage() {
  return <TrackV2Page />
}

export const getStaticProps = async context => {
  const v2StaticProps = await getV2StaticProps(context)

  return {
    ...v2StaticProps,
    props: {
      ...v2StaticProps.props,
      isV2: true,
    },
  }
}

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: true,
  }
}
